export default __webpack_public_path__ + "static/VAPORPEPE-8735aa14d7ace373290c9478e17d64b6.gif";